import * as React from "react";
const SvgBigBlueReceipt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={36}
    fill="none"
    {...props}
  >
    <path
      stroke="#466FF6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2.25}
      d="M31.5 9.507v3.267c0 2.133-1.35 3.483-3.483 3.483H23.4V6.82a2.725 2.725 0 0 1 2.727-2.713 5.43 5.43 0 0 1 3.793 1.58 5.43 5.43 0 0 1 1.58 3.82"
    />
    <path
      stroke="#466FF6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2.25}
      d="M4.5 10.857v18.9c0 1.12 1.269 1.755 2.16 1.08l2.309-1.728a1.36 1.36 0 0 1 1.782.135l2.24 2.254a1.36 1.36 0 0 0 1.918 0l2.268-2.268a1.34 1.34 0 0 1 1.755-.121l2.308 1.728c.891.661 2.16.027 2.16-1.08V6.807c0-1.485 1.215-2.7 2.7-2.7H9.9c-4.05 0-5.4 2.416-5.4 5.4z"
    />
    <path
      stroke="#466FF6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.25}
      d="M13.952 18.97h4.05M13.952 13.57h4.05M9.893 18.957h.012M9.893 13.557h.012"
    />
  </svg>
);
export default SvgBigBlueReceipt;
